// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: justify;
  gap: 20px;
  margin: 40px;
  opacity: 0;
  transition: opacity 1.3s ease-in-out;
}

.about-text-header {
  font-weight: var(--roboto-medium);
  color: var(--primary-color);
  font-size: 1.7rem;
  margin-top: 20px;
  max-width: 900px;
}

.visible {
  opacity: 1;
}

.about-text {
  font-weight: var(--roboto-regular);
  color: var(--primary-text);
  font-size: 1.2rem;
  max-width: 900px;
  line-height: 140%;
}

.about-text span {
  font-weight: var(--roboto-black);
  color: var(--primary-color);
  font-size: 2rem;
  display: block;
  margin: 10px 0px;
  line-height: 140%;
  text-align: center;
}

.about-text img {
  width: 200px;
  vertical-align: middle;
  cursor: default;
  margin-left: 5px;
}

.about-text a {
  text-decoration: none;
  color: var(--primary-color);
}

.about-text a:hover {
  color: var(--secondary-color);
}

.about-text ul {
  display: block;
  font-size: 0.9rem;
  text-align: left;
  margin-bottom: 20px;
  line-height: 180%;
}

@media screen and (max-width: 1020px) {
  .about-text {
    font-size: 1rem;
    max-width: 700px;
  }

  .about-text span {
    font-size: 1.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/about/About.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".about-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: justify;\r\n  gap: 20px;\r\n  margin: 40px;\r\n  opacity: 0;\r\n  transition: opacity 1.3s ease-in-out;\r\n}\r\n\r\n.about-text-header {\r\n  font-weight: var(--roboto-medium);\r\n  color: var(--primary-color);\r\n  font-size: 1.7rem;\r\n  margin-top: 20px;\r\n  max-width: 900px;\r\n}\r\n\r\n.visible {\r\n  opacity: 1;\r\n}\r\n\r\n.about-text {\r\n  font-weight: var(--roboto-regular);\r\n  color: var(--primary-text);\r\n  font-size: 1.2rem;\r\n  max-width: 900px;\r\n  line-height: 140%;\r\n}\r\n\r\n.about-text span {\r\n  font-weight: var(--roboto-black);\r\n  color: var(--primary-color);\r\n  font-size: 2rem;\r\n  display: block;\r\n  margin: 10px 0px;\r\n  line-height: 140%;\r\n  text-align: center;\r\n}\r\n\r\n.about-text img {\r\n  width: 200px;\r\n  vertical-align: middle;\r\n  cursor: default;\r\n  margin-left: 5px;\r\n}\r\n\r\n.about-text a {\r\n  text-decoration: none;\r\n  color: var(--primary-color);\r\n}\r\n\r\n.about-text a:hover {\r\n  color: var(--secondary-color);\r\n}\r\n\r\n.about-text ul {\r\n  display: block;\r\n  font-size: 0.9rem;\r\n  text-align: left;\r\n  margin-bottom: 20px;\r\n  line-height: 180%;\r\n}\r\n\r\n@media screen and (max-width: 1020px) {\r\n  .about-text {\r\n    font-size: 1rem;\r\n    max-width: 700px;\r\n  }\r\n\r\n  .about-text span {\r\n    font-size: 1.8rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
